import { FC } from 'react';
import { Text, View } from '@react-pdf/renderer';

import Table from '../PdfTable';
import styles from './styles';

interface DividendsProps {
  taxYear: string;
  dividends: Array<{
    companyName: string;
    investmentDate: string;
    date: string;
    formattedAmount: string;
    amount: number;
  }>;
  totalAmount: string;
}

const Dividends: FC<DividendsProps> = ({ taxYear, dividends, totalAmount }) => {
  if (!dividends.length) {
    return (
      <View wrap={false}>
        <Text style={styles.heading}>Dividends received</Text>
        <Text style={styles.paragraph}>
          You did not receive any dividend payments during the {taxYear} tax
          year.
        </Text>
      </View>
    );
  }

  return (
    <>
      <View wrap={false}>
        <Text style={styles.heading}>Dividends received</Text>
        <Text style={styles.paragraph}>
          You received the following taxable dividend income during this tax
          year:
        </Text>
      </View>

      <Table
        title={null}
        backgroundColor="white"
        fontColor="#333333"
        alignContent="left"
        fontSize={8}
        fullBorder
        collapseFooterBorderBottomWhenEmptyValue
        expandRows
        columns={{
          investment: { value: 'Investment', bold: true },
          investmentDate: {
            value: 'Investment date',
            bold: true,
            width: 22,
          },
          dividendPaymentDate: {
            value: 'Dividend payment date',
            bold: true,
            width: 22,
          },
          amount: {
            value: 'Dividend amount',
            bold: true,
            width: 22,
          },
        }}
        data={[
          ...dividends.map((dividend) => ({
            investment: {
              value: dividend.companyName,
            },
            investmentDate: {
              value: dividend.investmentDate,
              width: 22,
            },
            dividendPaymentDate: {
              value: dividend.date,
              width: 22,
            },
            amount: {
              value: dividend.formattedAmount,
              width: 22,
            },
          })),
        ]}
        footer={{
          investment: {
            value: '',
          },
          investmentDate: {
            value: '',
            width: 22,
          },
          interestsPaymentDate: {
            value: '',
            width: 22,
          },
          amount: {
            value: totalAmount,
            bold: true,
            width: 22,
          },
        }}
      />
      <Text style={[styles.paragraph, styles.topMargin]}>
        Each of the above dividend payments should be included in your tax
        return this year, except those issued by a UK Venture Capital Trust
        investment (which are exempt from UK dividend tax).
      </Text>
      <Text style={styles.paragraph}>
        If you pay tax in a non-UK jurisdiction, please seek professional tax
        advice before deciding which of the above dividends are subject to tax
        in your applicable jurisdiction.
      </Text>
    </>
  );
};

export default Dividends;
